import { BirdviewRowRelativeTime } from '../BirdviewRowRelativeTime'
import { DashboardListRow } from '../DashboardListRow'

import AnnouncementIcon from '../../../icons/notification.svg'

function BirdviewAnnouncementRow({ item, onOpen }) {
  function handleOpen() {
    onOpen(item)
  }

  return (
    <DashboardListRow
      Icon={AnnouncementIcon}
      Meta={BirdviewRowRelativeTime}
      actionKey='DashboardBirdview.RowActionReadKey'
      isUnread={item.unread}
      metaProps={{ date: item.published }}
      subtitle={item.address}
      title={item.title}
      onAction={handleOpen}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewAnnouncementRow
